import { BordOneToneIcon } from 'components/NudosComponents';
import { TcountryCode } from 'components/NudosComponents/BordFlag/BordFlag.types';
import BordPhoto from 'components/NudosComponents/BordPhoto/BordPhoto';
import { Link } from 'react-router-dom';

import { TplatformSubscription } from 'types/paymentDetails';

import './ClientAvatar.scss';

interface IClientAvatarData {
  id?: number;
  type?: TplatformSubscription;
  company?: string;
}

interface IClientAvatar {
  countryCode?: TcountryCode;
  imgUrl?: string;
  redirectionUrl?: string;
  data?: IClientAvatarData;
}

const COMPANY_TYPES_MAPPER: Record<TplatformSubscription, string> = {
  Free: 'Cliente Standard',
  Lite: 'Cliente Platinum',
  Vip: 'Cliente Platinum'
};

export const ClientAvatar = ({ countryCode, imgUrl, data }: IClientAvatar) => {
  const companyType = data?.type ? COMPANY_TYPES_MAPPER[data?.type] : '';

  return (
    <div className="clientAvatar">
      <BordPhoto
        variant="circle"
        size="s40"
        style={{
          border: '1px solid #B4B4B4'
        }}
        flagProps={
          countryCode
            ? {
                variant: 'circle',
                customWidth: '14px',
                country: countryCode,
                customClassName: 'clientAvatarFlag'
              }
            : undefined
        }
        imageProps={{
          style: {
            borderRadius: '100%',
            width: '40px',
            height: '40px'
          }
        }}
        oneToneIconProps={{
          variant: 'building3',
          standardSize: 18
        }}
        url={imgUrl}
      />
      <div className="clientAvatarDataSection">
        <div className="clientAvatarDataSectionContainer">
          <div className="clientAvatarDataSectionText">{data?.company}</div>
          {data?.id ? (
            <Link className="clientAvatarDataSectionRedirectionIcon" to={`/organization/details/${data?.id}`}>
              <BordOneToneIcon className="clientAvatarDataSectionIcon" variant="externalLink" customWidth="10px" />
            </Link>
          ) : null}
        </div>
        <div className="clientAvatarCompanyType">{companyType}</div>
      </div>
    </div>
  );
};
